import UserProfileModalBlock from './UserProfileModal';

export default UserProfileModalBlock;